module.exports = __webpack_public_path__ + "static/scale-model-of-downtown-disney-district-in-garden-grove-california-c757aad33f230bb27169a48bf3c36ce5.png";